// extracted by mini-css-extract-plugin
export default {"EditForm":"EditForm_EditForm__CDQuD"};